import { LogicLog } from "./logic-log";

export class PopupAlarm {
    public selectedAlarm: LogicLog = null;
    public duplicateAlarms: Array<LogicLog> = new Array<LogicLog>();
    public otherAlarmsPresent: boolean = false; 

    constructor(popupAlarmType?: any) {
        // used for assign type to instance of object
        if (popupAlarmType) {
          Object.assign(this, popupAlarmType);
        }
      }
}
